const w = (t, n) => {
  if (!t || !n)
    return {
      dropup: !1,
      pullRight: !1
    };
  const s = t.getBoundingClientRect(), e = s.x, o = s.y, c = t.offsetHeight, i = n.offsetWidth, p = n.offsetHeight, r = o - c - p - window.scrollY, l = window.innerHeight - (o + p + c + 10), f = e - i - window.scrollX, g = window.innerWidth - (e + i), h = l < 0 && (r >= 0 || r > l), a = g < 0 && (f >= 0 || f > g);
  return {
    dropup: h,
    pullRight: a
  };
};
export {
  w as default
};
//# sourceMappingURL=getDropDirection.js.map
